/* eslint-disable no-unused-vars */

/*
const plugToken =
  '6xLnkXriV75O4UkWVtbfKOMQDiV47aRBISGbCVXnAKqbx5uNaqfeIaOBVdZCkitk1gDaOgxdMQA9wNRyUQGbAiFboWZsPEK0u7QoDbWiO884L93McTE03m3HjQPMGbVIf2a6RQVi5RmtEaxRmHlWebljSLW3MpFHa2NRrvei3m1NbtluaOYPZc0FXTH1q2TeMMl7coc3rSLUc0fEjMndec53pGWff26aCY4HUTia9nxhvkhRdMpTYzx3y5aE5ZU2NmEFRdX01qrvijn35sBD2iT7pFMjdOuw1mWuRvDCaxEbxopzSsuYo5YJhrHtzoCXWSaNd0ceoROLb6ts9';
*/

import axios from 'axios';

export function GetIdentifier() {
  const webIdentifier = window.location.hostname;
  const configIdentifier = window.globalConfig?.IDENTIFICADOR;
  return webIdentifier.includes('newlink') ? webIdentifier : configIdentifier;
}

export async function GetDocumentos() {
  const plugToken = localStorage.getItem('plugtoken');
  const config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://app.plugsign.com.br/api/docs',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${plugToken}`,
    },
  };

  try {
    const response = await axios.request(config);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function GetFolders() {
  const plugToken = localStorage.getItem('plugtoken');
  const config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://app.plugsign.com.br/api/folders',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${plugToken}`,
    },
  };

  try {
    const response = await axios.request(config);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function GetDowloadFile(key) {
  const plugToken = localStorage.getItem('plugtoken');
  const config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `https://app.plugsign.com.br/api/files/download/${key}`,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${plugToken}`,
    },
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function GetFileHistory(key) {
  const plugToken = localStorage.getItem('plugtoken');
  const config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `https://app.plugsign.com.br/api/histories/${key}`,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${plugToken}`,
    },
  };

  try {
    const response = await axios.request(config);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function SendDocumentRequest({
  justLog,
  documentKey,
  subject = 'Assinatura de documento',
  certificate = false,
  widthPage = '800',
  observer = [],
  chain = false,
  sender = '',
  dueMonths = 12,
  silentMode = false,
  recipients = [],
}) {
  const plugToken = localStorage.getItem('plugtoken');
  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://app.plugsign.com.br/api/requests/documents',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${plugToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      document_key: documentKey,
      subject,
      certificate,
      width_page: widthPage,
      observer,
      chain,
      sender,
      due_months: dueMonths,
      silent_mode: silentMode,
      recipients,
    },
  };

  try {
    if (justLog) {
      console.log('TESTE');
      console.log(config);
      return;
    }

    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error(error.response?.data || error.message);
    throw error;
  }
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export async function UploadDocumento(justLog, file, name, folder) {
  const plugToken = localStorage.getItem('plugtoken');
  try {
    const base64File = await fileToBase64(file);

    const data = {
      file: base64File,
      name: name,
    };

    if (folder !== '') {
      data.folder = folder;
    }

    const config = {
      method: 'post',
      url: 'https://app.plugsign.com.br/api/files/upload',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${plugToken}`,
        'Content-Type': 'application/json',
      },
      data: data,
      maxBodyLength: Infinity,
    };

    if (justLog) {
      console.log(config);
      return;
    }

    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error(error.response?.data || error.message);
    throw error;
  }
}

export async function CreateFolder(justLog, name) {
  const plugToken = localStorage.getItem('plugtoken');
  try {
    const data = {
      name: name,
    };

    const config = {
      method: 'post',
      url: 'https://app.plugsign.com.br/api/folders',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${plugToken}`,
        'Content-Type': 'application/json',
      },
      data: data,
      maxBodyLength: Infinity,
    };

    if (justLog) {
      console.log(config);
      return;
    }

    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error(error.response?.data || error.message);
    throw error;
  }
}
